// Modules
import { useContext, useMemo } from 'react';
import { MappedPaymentComponentsType } from '@global/types/types';

// CSS and assets
import '@pages/checkout/components/SecurePayment/style.scss';

// Utils

import PaymentOptions from '@src/global/components/PaymentOptions';
import { ReloadInitResponseContext } from './SecurePayment';

import Card from '@src/global/components/WpsPayment/Card';
import { getPaymentMethodsCount } from '@src/global/utils/paymentMethodRules';

export const PaymentForm = () => {
  const { paymentInitData, paymentMethod, setPaymentMethod } = useContext(
    ReloadInitResponseContext
  );

  const paymentMethodsCount = getPaymentMethodsCount(paymentInitData);

  const paymentComponentMap: MappedPaymentComponentsType = useMemo(
    () => ({
      Card: Card,
    }),
    []
  );

  return (
    <PaymentOptions
      paymentMethod={paymentMethod}
      setPaymentMethod={setPaymentMethod}
      paymentMethodsCount={paymentMethodsCount}
      paymentInitData={paymentInitData}
      paymentComponentMap={paymentComponentMap}
    />
  );
};
